import type { Locale as DateFnsLocale } from "date-fns"
import { de, enUS } from "date-fns/locale"

const locales = ["en", "de"] as const

export const i18nConfig = {
  defaultLocale: "en",
  locales,
  localePrefixMode: "as-needed" as "always" | "as-needed",
  localePrefixes: {
    en: "/en",
    de: "/de",
  } satisfies Record<(typeof locales)[number], string>,
  dateFnsLocale: {
    de: de,
    en: enUS,
  } satisfies Record<(typeof locales)[number], DateFnsLocale>,
} as const

export type TI18nConfig = typeof i18nConfig
